const showSearchBtn = document.querySelector('.panel-item_icon_search');
const hideSearchBtn = document.querySelector('.header__search-close');

function toggleSearchPanel(e) {
  const headerSearchPanel = document.querySelector('.header__col_type_panel');

  function show() {
    document.body.style.overflow = 'hidden';
    headerSearchPanel.classList.add('header__col_active');
  }

  function hide() {
    document.body.style = null;
    headerSearchPanel.classList.remove('header__col_active');
  }

  return {
    show,
    hide,
  };
}

const searchPanel = toggleSearchPanel();

showSearchBtn.addEventListener('click', searchPanel.show);
hideSearchBtn.addEventListener('click', searchPanel.hide);

